"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const FormalReviewClient_1 = require("client/FormalReviewClient");
const CsvHelper_1 = require("utils/CsvHelper");
const HelperUtils_1 = require("utils/HelperUtils");
const socket_1 = require("utils/socket");
const Button_1 = __importDefault(require("components/design-system/Button"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const ImportSummary_1 = __importDefault(require("components/teams/modal/ModalImportTeam/ImportSummary"));
const UploadCsv_1 = __importDefault(require("components/teams/modal/ModalImportTeam/UploadCsv"));
const CSVScoreValidator_1 = require("./CSVScoreValidator");
const stepTitles = ['Import Score', 'Imported Score'];
const ModalImportScore = ({ eventClose, cycleId, getUserCycle }) => {
    const [step, setStep] = (0, react_1.useState)(0);
    const [selectedFile, setSelectedFile] = (0, react_1.useState)(null);
    const [fileErrorMessage, setFileErrorMessage] = (0, react_1.useState)(null);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refTimestamp = (0, react_1.useRef)(null);
    const [fileSuccessMessage, setFileSuccessMessage] = (0, react_1.useState)(null);
    const handleUploadCSV = () => {
        setLoading(true);
        if (!selectedFile) {
            setLoading(false);
            return;
        }
        // should convert to text first. because if directly parse .csv file, it cannot auto detecting the delimiter (tested too in https://www.papaparse.com/demo local file(s) sections)
        const reader = new FileReader();
        reader.readAsText(selectedFile);
        reader.onload = () => __awaiter(void 0, void 0, void 0, function* () {
            const result = reader.result;
            const parsedData = yield (0, CsvHelper_1.ParseFile)(result.replace(/\r/g, ''), {
                delimiter: '',
                skipEmptyLines: 'greedy'
            }, true);
            const { flag, parsedBody } = yield (0, CSVScoreValidator_1.validateContent)(parsedData, setFileErrorMessage);
            if (!flag) {
                return setLoading(false);
            }
            const currentTimestamp = new Date().toISOString().replace(/\.\d+/, '');
            refTimestamp.current = currentTimestamp;
            const { isSuccess } = yield (0, FormalReviewClient_1.importCycleScoreCSV)(cycleId, Object.assign(Object.assign({}, parsedBody), { timestamp: currentTimestamp }));
            if (!isSuccess) {
                setFileErrorMessage(`Failed to import file, please try again later`);
            }
            setLoading(false);
        });
    };
    const chooseFile = (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        e.target.value = '';
        setFileErrorMessage(null);
        if (!file)
            return;
        if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
            setFileErrorMessage('Please upload a file with .csv extension.');
        }
        setSelectedFile(file);
    };
    (0, react_1.useEffect)(() => {
        const listener = new socket_1.SocketListener();
        listener.register({
            name: socket_1.SocketChannels.backgroundJobProgress({
                type: 'cycle_import_answers'
            }),
            callback: (data) => {
                var _a;
                if (refTimestamp.current != ((_a = data === null || data === void 0 ? void 0 : data.object) === null || _a === void 0 ? void 0 : _a.timestamp))
                    return;
                setFileSuccessMessage(Object.assign({}, data === null || data === void 0 ? void 0 : data.object));
                setStep(1);
                getUserCycle();
            }
        });
        return () => {
            listener.unregister();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(Modal_1.default, { onClose: eventClose ? eventClose : () => null, closeOnClickOutside: !isLoading || step == 1, customClass: "w-[600px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)(selectedFile ? 'Upload your Score List' : stepTitles[0]), onClose: ((!isLoading || step == 1) && eventClose) || undefined }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px] w-full" },
                step == 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    isLoading && (react_1.default.createElement(BannerBox_1.default, { type: "info", text: (0, HelperUtils_1.getObjectiveLocale)("Closing this page will cause the import score summary can't be viewed"), borderRadiusClass: "rounded-lg", marginClass: "mb-[12px]" })),
                    react_1.default.createElement(UploadCsv_1.default, { chooseFile: chooseFile, selectedFile: selectedFile, fileErrorMessage: fileErrorMessage, removeFile: () => {
                            setSelectedFile(null);
                            setFileErrorMessage(null);
                        }, caption: (0, HelperUtils_1.getObjectiveLocale)('You can update the score by uploading the CSV and upload it in this modal section'), disabled: isLoading }))),
                step == 1 && (react_1.default.createElement(ImportSummary_1.default, { fileSuccessMessage: fileSuccessMessage, successCaptions: "Successfully imported score", useErrorCount: true })))),
        react_1.default.createElement(Modal_1.default.Footer, { customClass: "px-[24px] mt-[28px] mb-[24px] flex justify-between items-center", useBorder: false },
            react_1.default.createElement(react_1.default.Fragment, null, step == 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", Object.assign({ href: isLoading
                        ? '#'
                        : '/template/CSV-Formal-Review-PA-Khusus-Template.csv' }, (!isLoading
                    ? { download: 'template_CSV_Formal_Review_Score.csv' }
                    : []), { className: `${isLoading ? 'cursor-not-allowed' : ''} typography-button text-base-600` }), (0, HelperUtils_1.getObjectiveLocale)('Download CSV Template')),
                react_1.default.createElement(Button_1.default, { onClick: handleUploadCSV, isLoading: isLoading, disabled: step == 0 && (fileErrorMessage || !selectedFile)
                        ? true
                        : false }, (0, HelperUtils_1.getObjectiveLocale)('Import Score'))))))));
};
exports.default = ModalImportScore;
